import React, {Fragment, useState} from 'react';
import {useForm} from 'react-hook-form';

import { styles } from "./style";
import {AlertTypes, apiClient, Grid, DialogTitle, DialogContent, DialogActions, Dialog, Button} from "@leap4/frontend";
import {CredentialsType, IDataPointCredentials} from "@leap4/entities-discrepancy-common"
import {baseBackendRoute} from "../../../../config/generals";
import {CredentialsForm} from "../CredentialsForm";
import adServers from "../../adServers";

interface IProps {
    id: string;
}


interface IFormData extends Partial<IDataPointCredentials> {
    url: string;
}

const DialogUpdateDataPointCred = ({
                                       id,
                                   }: IProps): JSX.Element => {


    const {register, handleSubmit, reset} = useForm();
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)
    const [alert, setAlert] = useState<{showAlert: boolean; msg: string; alertStyle: React.CSSProperties}>({
        showAlert: false,
        msg: '',
        alertStyle: {},
    });

    const [credentials, setCredentials] = useState<IDataPointCredentials>({
        type: CredentialsType.PASSWORD,
        customData: {}
    });

    const handleFormChange = (e: any) => {
        let {name, value} = e.target;
        setCredentials({...credentials, [name]: value});
    }

    const LunchAlert = (msg: string, alertStyle: React.CSSProperties) => {
        //show the alert
        setAlert({showAlert: true, msg, alertStyle});
        setTimeout(() => {
            //hide  the alert tag
            setAlert({showAlert: false, msg: '', alertStyle: {}});
        }, 3500);
    };

    const onSubmit = async (e: any) => {
        e.preventDefault();
        e.stopPropagation()

        await handleSubmit(async () => {
            try {

                // TODO: Bad code, replace it with generic apiClient.
                await apiClient.patch(`${baseBackendRoute}/data-points/${id}/credentials`, {credentials});

                LunchAlert("Credentials changed successfully...", styles[AlertTypes.SUCCESS]);
            } catch (err) {
                LunchAlert('Error happened, try again later.', styles[String(AlertTypes.FAILURE)]);
            }
        })(e)
    };

    return (<Fragment>
            <Button size="large" variant="contained" color="primary" onClick={() => {
                setIsDialogOpen(true)
            }}>
                UPDATE CREDENTIALS
            </Button>
            <Dialog
                open={isDialogOpen}
                onClose={() => {
                    setIsDialogOpen(false)
                }}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    CREDENTIALS
                </DialogTitle>
                <DialogContent>
                    {alert.showAlert && (
                        <div style={{...styles.text, ...alert.alertStyle}}>
                            {alert.msg}
                        </div>
                    )}
                    <form
                        style={styles.form}
                        onSubmit={
                            onSubmit
                        }
                    >
                        <Grid container>
                            <CredentialsForm credentials={credentials} handleCredentialsPropChange={handleFormChange} adServerName={""}/>

                        </Grid>


                        <Button type="submit" variant="outlined"
                                style={{marginTop: "20px", padding: "10px 50px 10px 50px"}} color="primary">
                            Save
                        </Button>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setIsDialogOpen(!isDialogOpen)
                    }} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}

export default DialogUpdateDataPointCred;